import React, {useEffect, useState} from "react";
import { Database } from "../../config/config.js";
import { useParams } from 'react-router-dom';
import Result from './Result'
import "../../Style/Result.css";

const ResultContainer = () => {
  let { idResult, diasATrabajar } = useParams();
 
  return (
    diasATrabajar !== undefined && (
      <Result diasATrabajar={diasATrabajar} idResult={idResult} />
    )
  );
};;

export default ResultContainer;